import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// 为SSG导出必要的函数
export async function createSsrApp() {
  const app = createApp(App)
  const pinia = createPinia()
  
  app.use(pinia)
  app.use(router)
  
  return { app, router, pinia }
}

// 客户端渲染
if (!import.meta.env.SSR) {
  createSsrApp().then(({ app }) => {
    app.mount('#app')
  })
}